var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage3 = function SvgImage3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 800"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb900",
    d: "M0 0h600v800H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe8400",
    d: "M382.55 682.89 10 595.71v86.92zM382.55 682.89 10 266.21v155.31zM382.55 682.89 302.67 10H138.72zM382.55 682.89l211.72-393.88L590 10h-25.76zM382.55 682.89 590 578.5v-68.82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.23 399.11h88.65v5.64h-88.65z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M528.47 683.52V461.24h-22.29v5.13h-57.34c-10.84-89.43-37.68-264.29-66.29-264.29s-55.44 174.86-66.28 264.29h-57.74v-5.13h-21.89v222.28H10V790h580V683.52ZM368.75 466.37l3.1-8.86a11.33 11.33 0 0 1 21.41 0l3.1 8.86zM382.55 249c11.49 0 25.84 137.51 30.71 217.4h-6l-16-52.44a9.13 9.13 0 0 0-17.47 0l-16 52.44h-6c4.93-79.92 19.28-217.4 30.76-217.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb900",
    d: "M382.55 626.76s-10.4-23.55-44.32 17.93v37.92h88.65v-37.92c-33.88-41.48-44.31-17.97-44.33-17.93M470.85 559.12v38.94h-176.6v-38.94h28.52l6.8 19.46 6.8-19.46 6.8-19.48 25.58-73.27 3.1-8.86a11.33 11.33 0 0 1 21.41 0l3.1 8.86 25.58 73.27 6.8 19.48 6.8 19.46 6.8-19.46Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M580 780V20l20-20v800z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M0 800V0l20 20v760z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M580 20H20L0 0h600zM580 415H20L0 395h600z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b5b5",
    d: "M600 800H0l20-20h560zM600 405H0l20-20h560z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M285 385V20l20-20v405z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M315 20v365l-20 20V0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M305 0H0v800h600V0Zm285 10v385H305V10ZM10 10h285v385H10Zm0 780V405h580v385Z"
  })));
};
export default SvgImage3;